/* eslint no-bitwise: 0 */
/* eslint no-mixed-operators: 0 */

/*
    Generates a UUID v4.
    Copy-Pasta from https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
*/

const UUID = () =>
	"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
		const r = (Math.random() * 16) | 0;
		const v = c === "x" ? r : (r & 0x3) | 0x8;

		return v.toString(16);
	});

export default UUID;
